export const USER_PANEL_LOADING_SET = 'at/panels/user/editPanel/USER_PANEL_LOADING_SET'
export const EDIT_USER_ID_SET = 'at/panels/user/editPanel/EDIT_USER_ID_SET'
export const LOADED_SET = 'at/panels/user/editPanel/LOADED_SET'
export const UPDATING_DATA_SET = 'at/panels/user/editPanel/UPDATING_DATA_SET'
export const USER_PANEL_TAB_SET = 'at/panels/user/editPanel/USER_PANEL_TAB_SET'
export const USER_PANEL_STATE_SET = 'at/panels/user/editPanel/USER_PANEL_STATE_SET'
export const UPDATING_WORK_SCHEDULE_SET = 'at/panels/user/editPanel/UPDATING_WORK_SCHEDULE_SET'
export const ERROR_BACKUP_UPDATE = 'at/panels/user/editPanel/ERROR_BACKUP_UPDATE'
export const LAST_LICENSE_MANAGER_ON_DELETE_ALERT_SHOWN_SET = 'at/panels/user/editPanel/LAST_LICENSE_MANAGER_ON_DELETE_ALERT_SHOWN_SET'
export const LAST_LICENSE_MANAGER_ON_DISABLE_AT_ALERT_SHOWN_SET = 'at/panels/user/editPanel/LAST_LICENSE_MANAGER_ON_DISABLE_AT_ALERT_SHOWN_SET'
export const LAST_LICENSE_MANAGER_ON_DISABLE_AP_ALERT_SHOWN_SET = 'at/panels/user/editPanel/LAST_LICENSE_MANAGER_ON_DISABLE_AP_ALERT_SHOWN_SET'



// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/actionTypes.js